module.exports = __webpack_public_path__ + "fee59a35ffbe501a1286e73fb69b7a9c.png";